module.exports = __webpack_public_path__ + "img/1.78c7b129.png";